import { jsx, jsxs } from "react/jsx-runtime";
import dayjs from "dayjs";
import { Typography, Card, theme, Image, Grid } from "antd";
const { Text } = Typography;
const { useBreakpoint } = Grid;
const NewsCard = ({ item }) => {
  const { token } = theme.useToken();
  const screens = useBreakpoint();
  return /* @__PURE__ */ jsxs(
    Card,
    {
      hoverable: true,
      onClick: () => window.open(item.url, "_blank", "noopener,noreferrer"),
      style: {
        breakInside: "avoid",
        borderRadius: token.borderRadius,
        backgroundColor: token.colorBgCard,
        border: "none",
        marginBottom: screens.md ? 14 : 12,
        overflow: "hidden"
      },
      styles: {
        body: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
          padding: 10
        }
      },
      children: [
        /* @__PURE__ */ jsx(
          Image,
          {
            src: item.imageUrl,
            alt: item.title,
            width: "100%",
            height: screens.md ? 150 : 190,
            style: {
              objectFit: "cover",
              borderRadius: token.borderRadius,
              border: `1px solid ${token.colorBorder}`
            },
            preview: false
          }
        ),
        /* @__PURE__ */ jsx(
          Text,
          {
            strong: true,
            style: {
              display: "block",
              fontSize: token.fontSize,
              lineHeight: 1.45,
              marginTop: 10
            },
            children: item.title
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "space-between",
              gap: 8,
              marginTop: "auto",
              color: token.colorTextSecondary,
              fontSize: token.fontSizeSM
            },
            children: [
              /* @__PURE__ */ jsx("span", { children: item.source }),
              /* @__PURE__ */ jsx("span", { children: dayjs(item.publishedAt).format("MM/DD") })
            ]
          }
        )
      ]
    }
  );
};
var stdin_default = NewsCard;
export {
  stdin_default as default
};
